import * as d3 from 'd3';
import { maxBy } from 'lodash';
import React from 'react';
import VoxelTrendChip from '../../../components/voxel/Chips/VoxelTrendChip';

export interface LegendProps {
  dataSeriesInfo: DataSeriesInfo[];
  widthName?: string;
  widthLatest?: string;
  widthChange?: string;
  loadingPlaceholder: boolean;
}

export interface DataSeriesInfo {
  name: string;
  fillColorClass: string;
  latestValue: number;
  startValue: number;
}

export const Legend: React.FC<LegendProps> = ({
  dataSeriesInfo,
  widthName = 'w-16',
  widthLatest = 'w-6',
  widthChange = 'w-10',
  loadingPlaceholder,
}) => {
  const biggestNumber = maxBy(dataSeriesInfo, (x) => Math.abs(x.latestValue));
  const biggestChange = maxBy(dataSeriesInfo, (x) => Math.abs(x.latestValue - x.startValue));
  const formatter = d3.formatPrefix(',.0', biggestNumber?.latestValue);
  const formatterChange = d3.formatPrefix(
    ',.0',
    biggestChange?.latestValue - biggestChange?.startValue
  );

  if (loadingPlaceholder) {
    return (
      <div className="flex flex-row gap-2">
        <div className="w-full flex flex-col gap-2">
          <div className="w-10 h-4 bg-gray-200/50 rounded" />
          <div className="w-10 h-4 bg-gray-200/50 rounded" />
          <div className="w-10 h-4 bg-gray-200/50 rounded" />
          <div className="w-10 h-4 bg-gray-200/50 rounded" />
        </div>
        <div className="w-full flex flex-col gap-2">
          <div className="w-10 h-4 bg-gray-200/50 rounded" />
          <div className="w-10 h-4 bg-gray-200/50 rounded" />
          <div className="w-10 h-4 bg-gray-200/50 rounded" />
          <div className="w-10 h-4 bg-gray-200/50 rounded" />
        </div>
      </div>
    );
  }

  return (
    <div className="w-full flex flex-col">
      {dataSeriesInfo.map((series, index) => {
        const diff = series.latestValue - series.startValue;

        return (
          <div key={index} className="w-full flex flex-row flex-nowrap items-center gap-2">
            <div className={`flex-nowrap flex items-center ${widthName}`}>
              <svg width={10} height={10}>
                <circle r={4} cx={5} cy={5} className={`${series.fillColorClass}`} />
              </svg>
              <span className="whitespace-nowrap pl-2 text-gray-700 text-xs font-sans font-medium">
                {series.name}
              </span>
            </div>
            <span
              className={`whitespace-nowrap text-gray-700 text-xs ${widthLatest} text-right font-sans font-medium`}
            >
              {formatter(series.latestValue)}
            </span>
            <VoxelTrendChip
              color={diff > 0 ? 'success' : diff < 0 ? 'error' : 'neutral'}
              title={
                <>
                  {diff > 0 ? '+' : ''}
                  {formatterChange(diff)}
                </>
              }
              size="xxs"
            />
          </div>
        );
      })}
    </div>
  );
};

export default Legend;
